export default class TokenManager {
  static myInstance = null;

  _tokens = [];

  getTokens() {
    return this._tokens;
  }

  addToken(x) {
    this._tokens.push(x);
  }

  removeToken(id) {
    this._tokens = this._tokens.filter((t) => t.id !== id);
  }

  canelTokens() {
    if (this._tokens.length) {
      this._tokens.forEach((token) =>
        token.source.cancel('Operation canceled by the user.')
      );
      this._tokens = [];
    }
  }

  /**
   * @returns {TokenManager}
   */
  static getInstance() {
    if (TokenManager.myInstance == null) {
      TokenManager.myInstance = new TokenManager();
    }

    return this.myInstance;
  }
}

//const tm = TokenManager.getInstance();
